import React from "react";
import UsersOverview from "../components/usersPage/UsersOverview";

export default function UsersPage(): JSX.Element {
  return <UsersOverview />;
}
